class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', this.relatedProducts.bind(this));
  }

  relatedProducts() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      
      observer.unobserve(relatedProductsSection);
      
      const url = relatedProductsSection.dataset.url;
      
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.related-products');
  
          if (recommendations && recommendations.innerHTML.trim().length) {
            relatedProductsSection.innerHTML = recommendations.innerHTML;
            productCardColorUpdateFunction();
            productCardColorSwatchesScroll();
            this.createSlider();
          }
        })
        .catch(e => {
          console.error(e);
        });
    };
  
    const relatedProductsSection = document.querySelector('.related-products');
    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: 0,
      rootMargin: '1000px'
    });
  
    observer.observe(relatedProductsSection);
  }

  createSlider() {
    // Prevent click event when dragging
    var drag = false;

    // Allow more than one slider at the same time
    document.querySelectorAll('.related-products__recommendations').forEach(slider => { 
      new KeenSlider(slider, {
        dragChecked() {
          drag = true;
        },
        dragEnded() {
          setTimeout(() => (drag = false), 0);
        },
        created() {
          document.querySelectorAll('.related-products__recommendations').forEach(slider => {
            slider.addEventListener("click", (e) => {
              if (drag) {
                e.stopPropagation();
                e.preventDefault();
              }
            })
          });
        },
        breakpoints: {
          '(max-width: 449px)': {
            slides: {
              perView: 1.35,
              spacing: 16
            }
          },
          '(min-width: 450px)': {
            slides: {
              perView: 2.5,
              spacing: 20
            }
          },
          '(min-width: 990px)': {
            disabled: true,
          },
        },
      }, [navigation])
    })
  }
}

customElements.define('related-products', RelatedProducts);